import { GoogleLogin } from "@react-oauth/google";
import axios from "axios";
import { API_IP } from "../global_variables";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

const LoginButton = ({ setLogin, setUser }) => {
  const navigate = useNavigate();
  const handleLoginSuccess = async (credentialResponse) => {
    console.log("Login Success:", credentialResponse);
    const { data } = await axios({
      method: "post",
      url: `${API_IP}/api/googleLogin`,
      headers: {},
      data: {
        idToken: credentialResponse.credential,
        device_token: null,
        platform: "web", // This is the body part
      },
    });
    localStorage.setItem("token", data.token);
    localStorage.setItem("username", data.username);
    localStorage.setItem("userId", data.userId);
    navigate("/main", {
      state: { user: { username: data.username } },
    });
    setLogin(true);

    setUser({ username: data.username, userId: data.userId });

    console.log("Login successful:", data);
    // Handle the successful login response (e.g., send the token to your backend)
  };

  const handleLoginFailure = () => {
    console.log("Login Failed");
    toast.error("Google login failed. Please try again.");
  };

  return (
    <div className="AuthGoogleWrap">
      <GoogleLogin onSuccess={handleLoginSuccess} onError={handleLoginFailure} />
    </div>
  );
};
export default LoginButton;
